<script>
import axios from 'axios';
import Select from './Select.vue';
import MixinsVue from '../mixins/Vue.js';

export default {
    extends: Select,
    components: {
        Select,
    },
    props: {
        originalInputPlaceholderText: String,
        dropdownContainerId: String,
        user: {
            type: Object,
            default: function () {
                return appData.page.vars.user;
            },
        },
    },
    data() {
        return {
            mixins: MixinsVue.methods.vue,
            options: [],
            timezones: [],
            selectedTimezone: null,
            selectInputName: 'select-timezone',
            selectOption: 'select-timezone',
            hasBeenLoaded: false,
            token: document.querySelector('meta[name="csrf-token"]').content,
        };
    },
    computed: {
        inputPlaceholderText: function () {
            let userTimezone = this.app.locale.getUserTimezone();
            let userUtcOffset =
                this.mixins.methods.convertTimezoneToUtcOffset(userTimezone);
            let selectPlaceholder = 'UTC';
            selectPlaceholder +=
                userUtcOffset >= 0 ? '+' + userUtcOffset : userUtcOffset;
            selectPlaceholder += ' (' + userTimezone + ')';
            return selectPlaceholder;
        },
    },
    mounted() {
        // Only load timezones list when needed
        if (this.dropdownContainerId) {
            let dropdown = this.app.lib.jQuery('#' + this.dropdownContainerId);
            dropdown.on('shown.bs.dropdown', () => {
                this.loadTimezones();
            });
        } else {
            this.loadTimezones();
        }
    },
    watch: {
        selectInputValue(value) {
            this.filterOptions(value);
        },
    },
    methods: {
        select(locale) {
            this.selectedLocale = locale;
            this.selectInputValue = this.optionLabel(locale);
            Select.methods.select.call(this, locale);
        },
        optionLabel(option) {
            return option.full_label;
        },
        loadTimezones() {
            // Avoid loading timezones several times
            if (!this.hasBeenLoaded) {
                axios
                    .get('/api/timezones', {
                        headers: {
                            'X-CSRF-TOKEN': this.token,
                        },
                    })
                    .then(
                        (success) => {
                            this.options = this.timezones = JSON.parse(
                                success.data
                            );
                            this.hasBeenLoaded = true;
                        },
                        (error) => {
                            // Log error on the console for debug purpose
                            console.error(error.response.status);
                            console.error(error.message);
                            console.error(error.response.data);
                            console.error(error.response.headers);
                        }
                    );
            }
        },
        filterOptions(string) {
            // Allow timezones filtering when typing in the select input
            string = string && string.trim();
            if (!string) {
                this.options = this.timezones;
            } else {
                string = this.app.string.slugify(string);
                this.options = this.timezones.filter((timezone) => {
                    // Ignore special chars.
                    let label = this.app.string.slugify(
                        this.optionLabel(timezone)
                    );
                    return !timezone.id || label.indexOf(string) !== -1;
                });
            }
        },
    },
};
</script>
